function PagePlaceholder({ title }) {
  return (
    <section className="pr-placeholder">
      <div className="container">
        <h1>{title}</h1>
        <p>This route is scaffolded and ready for page-by-page migration from EJS.</p>
      </div>
    </section>
  );
}

export default PagePlaceholder;
